<template>
  <div v-if="isAuthorized" @click="openBoosterModal">
    🦍
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  name: 'booster-button',
  props: ['payload'],
  data () {
    return {
      owner: this.$utils.getOwner().name
    }
  },
  computed: {
    isAuthorized () {
      return this.owner == 'הראל קפלן'
    }
  },
  methods: {
    openBoosterModal () {
      this.create({
        designator: 'offer-booster-form-modal',
        component_name: 'OfferBoosterForm',
        modal_width: 1200,
        is_center_modal: true,
        data: this.payload,
        resource_type: 'Offer',
        modal_title: 'Booster evaluation'
      })
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>
